import React from 'react';
import AddDeceasedPoster from './PartnerPanelPages/AddDeceasedPoster';
import AddDeceased from './AdminPanelPages/AddDeceased';
import ModifyAddDeceased from './AdminPanelPages/ModifyAddDeceased';

let close = true;
export default function ModifyDeceasedPage(props) {
	return (
		<div
			className="bg-modal"
			style={{ overflow: 'auto', padding: 40 }}
			onClick={() => {
				close ? props.closeHandler() : (close = true);
			}}
		>
			<div
				onClick={() => {
					close = false;
				}}
				style={{ height: '100%' }}
			>
				<ModifyAddDeceased partner={props.partner} modify={props.data || true} />
			</div>
		</div>
	);
}
